var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"icon",class:_vm.className,attrs:{"width":"24","height":"24"}},_vm.$listeners),[_c('use',_vm._b({},'use',{'href':'/svg-sprite.svg#'+_vm.icon},false))])}
var staticRenderFns = []

export { render, staticRenderFns }